<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33334 6.66667C1.33334 6.66667 2.67 4.84548 3.7559 3.75883C4.8418 2.67218 6.34241 2 8.00001 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8.00001 14C5.26461 14 2.95675 12.1695 2.23452 9.66667M1.33334 6.66667V2.66667M1.33334 6.66667H5.33334"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
